import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { additionalProfileGuard } from '@auth/guards/additional-profile.guard';
import { agentSelectionGuard } from '@auth/guards/agent-selection.guard';
import { authorizedOnlyGuard } from '@auth/guards/authorized-only.guard';
import { listingAuthorizedGuard } from '@auth/guards/listing-authorized.guard';
import { listingGuard } from '@auth/guards/listing.guard';
import { myListingsGuard } from '@auth/guards/my-listings.guard';
import * as notAuthorizedOnlyGuard from '@auth/guards/not-authorized-only.guard';
import { profilesGuard } from '@auth/guards/profiles.guard';
import { searchGuard } from '@auth/guards/search.guard';
import { mortgageReportMatcher } from '@core-matchers/mortgage-report.matcher';
import { sharedListingDetailsMatcher } from '@core-matchers/shared-listing.matcher';
import { DeprecatedRpcRoute } from './models/deprecated-rpc-route';
import { RpcRoute } from './models/rpc-route';
import { LandingModule } from '@landing/landing.module';

const routes: Routes = [
    {
        path: RpcRoute.Portfolio,
        loadChildren: () => import('@my-listings/my-listings.module').then(m => m.MyListingsModule),
        canActivateChild: [authorizedOnlyGuard, myListingsGuard]
    },
    {
        path: RpcRoute.SearchListings,
        loadChildren: () => import('@on-market/on-market.module').then(m => m.OnMarketModule),
        canActivateChild: [authorizedOnlyGuard, searchGuard]
    },
    {
        path: RpcRoute.Appointments,
        loadChildren: () => import('@my-appointments/my-appointments.module').then(m => m.MyAppointmentsModule),
        canActivateChild: [authorizedOnlyGuard]
    },
    {
        path: RpcRoute.Listing,
        loadChildren: () => import('@internal-listing-details/internal-listing-details.module').then(m => m.InternalListingDetailsModule),
        canActivateChild: [listingAuthorizedGuard, listingGuard]
    },
    {
        matcher: sharedListingDetailsMatcher,
        loadChildren: () => import('@shared-listing-details/shared-listing-details.module').then(m => m.SharedListingDetailsModule)
    },
    {
        path: RpcRoute.Profile,
        loadChildren: () => import('@profile/profile.module').then(m => m.ProfileModule),
        canActivateChild: [authorizedOnlyGuard, profilesGuard]
    },
    {
        path: RpcRoute.NewMatch,
        loadChildren: () => import('@listing-id-encrypting/listing-id-encrypting.module').then(m => m.ListingIdEncryptingModule)
    },
    {
        path: RpcRoute.AdditionalProfile,
        loadChildren: () => import('@additional-profile/additional-profile.module').then(m => m.AdditionalProfileModule),
        canActivateChild: [authorizedOnlyGuard, additionalProfileGuard]
    },
    {
        path: RpcRoute.AgentSelection,
        loadChildren: () => import('@agent-selection/agent-selection.module').then(m => m.AgentSelectionModule),
        canActivateChild: [notAuthorizedOnlyGuard.canActivateChild, agentSelectionGuard]
    },
    {
        path: RpcRoute.KnowledgeBase,
        loadChildren: () => import('@knowledge-base/knowledge-base.module').then(m => m.KnowledgeBaseModule),
        canActivateChild: [authorizedOnlyGuard]
    },
    {
        path: RpcRoute.FindHome,
        loadChildren: () => LandingModule,
        // loadChildren: () => import('@landing/landing.module').then(m => m.LandingModule),
        canActivateChild: [authorizedOnlyGuard]
    },
    {
        path: RpcRoute.NotFound,
        loadChildren: () => import('@error/error.module').then(m => m.ErrorModule)
    },
    {
        loadChildren: () => import('@mortgage-report/mortgage-report.module').then(m => m.MortgageReportModule),
        matcher: mortgageReportMatcher,
    },
    { path: DeprecatedRpcRoute.OnMarket, redirectTo: RpcRoute.FindHome, pathMatch: 'full' },
    { path: DeprecatedRpcRoute.Dashboard, redirectTo: RpcRoute.Portfolio, pathMatch: 'full' },
    { path: DeprecatedRpcRoute.MyListings, redirectTo: RpcRoute.Portfolio, pathMatch: 'full' },
    { path: DeprecatedRpcRoute.MyPortfolio, redirectTo: RpcRoute.Portfolio, pathMatch: 'full' },
    { path: DeprecatedRpcRoute.RemovedListingsFolder, redirectTo: RpcRoute.Portfolio, pathMatch: 'full' },
    { path: DeprecatedRpcRoute.ExrernalListingsFullPath, redirectTo: RpcRoute.Portfolio, pathMatch: 'full' },
    { path: DeprecatedRpcRoute.MyAppointments, redirectTo: RpcRoute.Appointments, pathMatch: 'full' },
    { path: '', redirectTo: RpcRoute.Login, pathMatch: 'full' },
    { path: '**', redirectTo: RpcRoute.NotFound, pathMatch: 'full' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'ignore', preloadingStrategy: PreloadAllModules })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
